import certificates from '../../../assets/sidemenu/diploma-active.svg'
import stock from '../../../assets/sidemenu/box-active.svg'
import production from '../../../assets/home/production.svg'
import orders from '../../../assets/sidemenu/clipboard-active.svg'
import people from '../../../assets/assesses/accesses.svg'
import company from '../../../assets/home/companies.svg'
import equipment from '../../../assets/router/routersTabHeader/vehicle-active.svg'
import products from '../../../assets/home/length.svg'
import steel from '../../../assets/home/steel.svg'
import local_act from '../../../assets/sidemenu/local-active.svg';
import service from '../../../assets/home/service.svg'
import resource from '../../../assets/home/resource.svg'

interface AppType {
  nameApp: string
  image: string
  path: string
}

interface AppSectionType {
  nameSection: string
  apps: AppType[]
}

export const applications:AppSectionType[] = [
  {
    nameSection: 'Aplicações',
    apps: [
      { nameApp: 'Certificados', image: certificates, path: 'certificates' },
      { nameApp: 'Estoque', image: stock, path: 'stock' },
      // { nameApp: 'Produção', image: production, path: 'production' },
      // { nameApp: 'Pedidos aço', image: steel, path: 'steel' },
      {nameApp: 'Roterização', image:local_act, path:'router'}
    ]
  },
  {
    nameSection: 'Banco de dados',
    apps: [
      { nameApp: 'Rastreio de pedidos', image: orders, path: 'orders' },
      { nameApp: 'Pessoas', image: people, path: 'people' },
      { nameApp: 'Empresas', image: company, path: 'companies' },
      //{ nameApp: 'Produtos', image: products, path: 'products' },
      // { nameApp: 'Etapas', image: company, path: 'companies' },
      // { nameApp: 'Màquinas', image: company, path: 'companies' },
      { nameApp: 'Veículos', image: equipment, path: 'equipment' },
    ]
  },
]